<div>
    <div *ngIf="remainingUsersBelowTreshold" class="alert alert-warning border-warning mx-4 mt-2 default-font-size" role="alert">
        <span class="lh-sm" innerHTML="{{ 'Settings.OrganisationUsersSection.WarningNoLicenses'  | translate: {url: supportUrl} }}"></span>
    </div>
    
    <h3 class="title" translate>Settings.OrganisationUsersSection.Title</h3>
</div>

<div class="p-4 pt-1">
    <form>
        <div class="row">
            <div class="col-6 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5">
                <input type="text" class="form-control" id="inputSearch" placeholder="{{ 'Settings.OrganisationUsersSection.Search' | translate }}" (keyup)="applyFilter($event)">
            </div>
            <div class="offset-lg-1 offset-xl-1 offset-xxl-1 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end">
                <button type="button" id="buttonSave" class="btn btn-sm btn-secondary me-1" [disabled]="remainingUsers < 1" (click)="addUser()">
                    <span translate>Settings.OrganisationUsersSection.AddUser</span> <span class="badge border-radius-profile ms-2" [ngClass]="{'bg-success': remainingUsers > 0, 'bg-danger': remainingUsers === 0 }">{{remainingUsers}}</span>
                </button>
            </div>
        </div>
        <app-userList [users]="users" [organisation]="organisation && organisation.organisation" [filter]="filter" (refreshUsers)="reloadUsers()"></app-userList>
    </form>
</div>